import { createFileRoute } from '@tanstack/react-router';

import { Integrations, UTMConfig } from '@mint-sdk/api-trafficking-ga4';

export const Route = createFileRoute(
  '/_secured/campaign/$campaignId/trafficking/analytics/',
)({
  loaderDeps: ({ search: { activityId } }) => ({ activityId }),
  loader: async ({ context, deps: { activityId } }) => {
    await context.getInstance('i18n', '@myn/trafficking-ga4_v2');
    const isOmniTrafficking = await context.isFlagEnabled(
      '@mint/arm',
      'omniTrafficking',
    );

    if (isOmniTrafficking) {
      context.prefetchQuery(Integrations.getIntegrationsQueryOptions({}));
    }

    if (isOmniTrafficking && activityId) {
      context.prefetchQuery(
        UTMConfig.getUTMConfigQueryOptions({
          params: {
            activityId,
          },
        }),
      );
    }
  },
});
